import React,{ useEffect } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

// Add this custom hook to your component file or a separate hooks file:
function useNavigationBlocker(when: boolean, message: string) {
  const navigator = React.useContext(UNSAFE_NavigationContext).navigator as any;

  useEffect(() => {
    if (!when) return;

    const originalPush = navigator.push;
    const originalReplace = navigator.replace;

    navigator.push = (...args: any[]) => {
      const result = window.confirm(message);
      if (result) {
        originalPush(...args);
      }
    };

    navigator.replace = (...args: any[]) => {
      const result = window.confirm(message);
      if (result) {
        originalReplace(...args);
      }
    };

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
    };
  }, [when, message, navigator]);
}
export default useNavigationBlocker;